import React from 'react';
import NoResults from '@molecules/NoResults/NoResults';
import NoSaved from '@molecules/NoSaved/NoSaved';
import { useSearchResults } from '@context/DataContext';

export const EmptyResults = () => {
  const { resultTab } = useSearchResults();
  return resultTab && resultTab === 'saved' ? <NoSaved /> : <NoResults />;
};
export default EmptyResults;
